const routes = [
    {
        path: "/coop/student/event",
        redirect: { path: "/coop/student", query: { tab: 1 } }
    },
    {
        path: "/coop/admin/event",
        component: () => import("../pages/AdminIndex"),
        meta: {
            isAuthenticated: true
        }
    },
    {
        path: "/coop/admin/event/:id/applications",
        component: () => import("../pages/EventApplications"),
        meta: {
            isAuthenticated: true
        }
    }
];

export default routes;
